import { render, staticRenderFns } from "./announs.vue?vue&type=template&id=00193d50&scoped=true"
import script from "./announs.vue?vue&type=script&lang=js"
export * from "./announs.vue?vue&type=script&lang=js"
import style0 from "./announs.vue?vue&type=style&index=0&id=00193d50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00193d50",
  null
  
)

export default component.exports